import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-ink sm:py-24" data-id="element-82" data-mp="3uei2ph2cts2v">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-83" data-mp="c8c21b44epg7">
        <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-6xl" data-id="element-84" data-mp="85fgpcn74f8k">
          Your Step Classes.
          <br data-id="element-85" data-mp="m3nhxwr9m2pj" />
          <span className="text-green-dark" data-id="element-86" data-mp="m33z8dtsjaag">Ready in 5 Minutes.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-87" data-mp="h52frrsgd8yg">
          Join hundreds of professional step instructors who have stopped improvising and started teaching with a
          complete, structured, printable system.
        </p>
        <div className="mt-10" data-id="element-88" data-mp="14uwtscoid3ka">
          <Countdown dark={false} data-id="element-89" data-mp="14w7ta0ax7p5l" />
        </div>
        <div className="mt-10" data-id="element-90" data-mp="zwd2dwr5azkj">
          <CTAButton size="large" data-id="element-91" data-mp="zxei4ej3wa8l">🚀 Get Instant Access — $19 USD</CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-92" data-mp="2c5g7m9or38xj">
          🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-Day Guarantee · 💳 Card · PayPal · ♾️ Lifetime Access
        </p>
      </Reveal>
    </section>;
}